import * as angular from "angular";
import {IController, IQService, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {DataSet} from "vis-data";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ResourcesAllocationsTimelineCtrl implements IController {
  range: any;
  isDayView: any;
  resources: any;
  totalResourcesCount: any;
  allocations: any;
  serviceAreas: any;
  resourceTags: string[];
  selectedItemId: any;
  canEdit: boolean;
  queryString: any;
  selectedResourceIds: string[];
  isAllResourcesSelected: boolean;
  highlightedAllocations: any[];
  onAllocationSelection: Function;
  onAllocationRightClick: Function;
  onMoveAllocation: Function;
  onCreateAllocation: Function;
  onResourceAction: Function;
  onResourceSelect: Function;
  onToggleSelectAll: Function;
  onBulkEditResourceAllocation: Function;
  onBulkEditResources: Function;
  onHighlightAllocations: Function;

  public groupsViewSettings: any;
  private container: any;
  private vis: any;
  private rrule: any;
  private options: any;
  private timeline: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private readonly timeFormat: string;
  private readonly longDateFormat: any;
  private shortDateFormat: any;
  private timeZone: any;
  private itemsDataSet: any;
  private serviceAreasMap: any;
  private _redrawTimeoutHandle: any;

  /////////// ICONS ///////////
  private iconsUrl: any;
  private $menuIcon: any;
  private $groupIcon: any;
  private $agentTypeIcon: any;
  private $branchIcon: any;
  private $serviceAreaIcon: any;
  private $resourceTagsIcon: any;
  private $blockedResourcesIcon: any;
  private $defaultAgentIcon: any;
  private $recurringIcon: any;
  private $priorityIcon: any;
  private $timeZoneIcon: any;

  // Single delegated click handler for all group-row actions, attached once on
  // `this.container` after the timeline is created. Replaces 6 per-cell
  // `addEventListener` calls inside `groupTemplate`. Per-group context is
  // re-fetched from `groupsDataSet` on click — fresher than the previous
  // closure capture.
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;

    const group: any = this.groupsDataSet ? this.groupsDataSet.get(id) : null;

    this._onClicked().then(() => {
      if (action === 'resource-action') {
        if (group?.ref) {
          this.onResourceAction({resource: group.ref, event: event});
        }
      } else if (action === 'select-resource') {
        this.onResourceSelect({resourceId: id, event: event});
      } else if (action === 'show-branches') {
        if (group?.branchReferences?.length) {
          this.commonsDialogService.displayEntityLinksList('branch.shipper-accounts', group.branchReferences, 'branches.get', event);
        }
      } else if (action === 'show-service-areas') {
        const serviceAreaIds: string[] = group?.ref?.serviceAreaIds || [];
        if (!serviceAreaIds.length) return;
        const serviceAreas = this._getServiceAreasByMap(serviceAreaIds);
        const serviceAreaReferences = _.map(serviceAreas, (sa: any) => ({id: sa.areaId, name: sa.areaName}));
        this.commonsDialogService.displayEntityLinksList(undefined, serviceAreaReferences, undefined, event);
      } else if (action === 'show-resource-tags') {
        const tags: string[] = group?.ref?.tags || [];
        if (!tags.length) return;
        const resourceTagReferences = _.map(tags, (t: string) => ({id: `tag-${t}`, name: t}));
        this.commonsDialogService.displayEntityLinksList(undefined, resourceTagReferences, undefined, event);
      }
    });
  };

  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private commonsService: CommonsService,
              private splitService: SplitService, private commonsDialogService: CommonsDialogService, private moment, private $timeout: ITimeoutService,
              private bringozTimelineService: BringozTimelineService, private $state, private $window: IWindowService) {
    this.vis = require('vis-timeline');
    this.rrule = require('rrule');
    const dateAndTimeConfig = this.splitService.getDateAndTimeConfig();
    this.timeFormat = dateAndTimeConfig.time;
    this.shortDateFormat = dateAndTimeConfig.date;
    this.longDateFormat = dateAndTimeConfig.long;
    this.timeZone = this.splitService.getTimeZone();
  }

  $onInit() {
    this.groupsViewSettings = {
      skills: true,
      branches: true,
      serviceAreas: true,
      resourceTags: true,
      defaultAgent: false,
      vehicle: false,
      blockedResources: true
    }
    this.iconsUrl = {
      group: 'assets/images/icons/v2/resource.svg',
      agentType: 'assets/images/icons/v2/agent.svg',
      branch: 'assets/images/icons/v2/branch.svg',
      serviceArea: 'assets/images/icons/v2/service-area.svg',
      resourceTags: 'assets/images/icons/v2/tag.svg',
      defaultAgent: 'assets/images/icons/v2/default-agent.svg',
      routed: 'assets/images/icons/v2/route.svg',
      menu: 'assets/images/icons/v2/menu.svg',
      recurring: 'assets/images/icons/v2/recurring.svg',
      priority: 'assets/images/icons/v2/priority.svg',
      timeZone: 'assets/images/icons/v2/time-zone.svg',
      warning: 'assets/images/icons/v2/error.svg'
    }

    this.$groupIcon = document.createElement('IMG');
    this.$groupIcon.setAttribute("src", this.iconsUrl.group);
    this.$groupIcon.classList.add('bringoz-icon-small', 'white');

    this.$agentTypeIcon = document.createElement('IMG');
    this.$agentTypeIcon.setAttribute("src", this.iconsUrl.agentType);
    this.$agentTypeIcon.classList.add('bringoz-icon-small', 'gray');


    this.$branchIcon = document.createElement('IMG');
    this.$branchIcon.setAttribute("src", this.iconsUrl.branch);
    this.$branchIcon.classList.add('bringoz-icon-small', 'gray');

    this.$serviceAreaIcon = document.createElement('IMG');
    this.$serviceAreaIcon.setAttribute("src", this.iconsUrl.serviceArea);
    this.$serviceAreaIcon.classList.add('bringoz-icon-small', 'gray');

    this.$resourceTagsIcon = document.createElement('IMG');
    this.$resourceTagsIcon.setAttribute("src", this.iconsUrl.resourceTags);
    this.$resourceTagsIcon.classList.add('bringoz-icon-small', 'gray');

    this.$blockedResourcesIcon = document.createElement('IMG');
    this.$blockedResourcesIcon.setAttribute("src", this.iconsUrl.warning);
    this.$blockedResourcesIcon.classList.add('bringoz-icon-small', 'gray');

    this.$defaultAgentIcon = document.createElement('IMG');
    this.$defaultAgentIcon.setAttribute("src", this.iconsUrl.defaultAgent);

    this.serviceAreasMap = _.keyBy(this.serviceAreas, 'areaId');

    this.$menuIcon = document.createElement('IMG');
    this.$menuIcon.setAttribute("src", this.iconsUrl.menu);
    this.$menuIcon.classList.add('bringoz-icon-small');

    this.$recurringIcon = document.createElement('IMG');
    this.$recurringIcon.setAttribute("src", this.iconsUrl.recurring);
    this.$recurringIcon.classList.add('bringoz-icon-small', 'white', 'margin-0');

    this.$priorityIcon = document.createElement('IMG');
    this.$priorityIcon.setAttribute("src", this.iconsUrl.priority);
    this.$priorityIcon.classList.add('bringoz-icon-small', 'gray');


    this.$timeZoneIcon = document.createElement('IMG');
    this.$timeZoneIcon.setAttribute("src", this.iconsUrl.timeZone);
    this.$timeZoneIcon.classList.add('bringoz-icon-small', 'margin-0', 'white');


    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = false;
    }

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet()
    this.itemsDataSet = new DataSet()


    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.value - b.value;
      },
      order: (a, b) => {
        return a?.className === 'agent' ? 1 : -1;
      },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {

        // const routesCount = _.filter(this.routes, (r) => {
        //   return _.get(r, 'agentId') === _.get(group, 'ref.id')
        // }).length;

        if (!group) {
          return null;
        }

        const mainContainer = document.createElement('div');
        mainContainer.classList.add("group-container");

        if (!group.ref.tags?.length) {
          mainContainer.classList.add("no-tags");
        }

        const groupColor = this.commonsService.getColorById(group.id);
        const colorContainer = document.createElement('div');
        colorContainer.setAttribute('style', `background: ${groupColor}`);
        colorContainer.classList.add("group-color-container");

        const actionsContainer = document.createElement('div');
        actionsContainer.classList.add("group-actions-container");

        const resourceCheckbox: any = document.createElement("INPUT");
        resourceCheckbox.setAttribute("type", "checkbox");
        if (this.selectedResourceIds.includes(group.id)) {
          resourceCheckbox.setAttribute("checked", true);
        }
        if (group.id) {
          resourceCheckbox.dataset.bzAction = 'select-resource';
          resourceCheckbox.dataset.bzId = String(group.id);
        }
        actionsContainer.appendChild(resourceCheckbox);

        const actionButton = this.$menuIcon.cloneNode(true);
        actionButton.classList.add("md-icon-button", "group-action-button", "bringoz-icon");
        if (group.id) {
          actionButton.dataset.bzAction = 'resource-action';
          actionButton.dataset.bzId = String(group.id);
        }
        actionsContainer.appendChild(actionButton);


        const infoContainer = document.createElement('div');
        infoContainer.classList.add("group-info-container");


        // Agent Name Row
        const nameRow = document.createElement('div');
        nameRow.classList.add("group-info-row");

        // Resource Name
        const groupNameSpan = document.createElement('a');
        groupNameSpan.classList.add("agent-name", "text-ellipsis", "br-body-2", "font-weight-600");
        groupNameSpan.innerText = group.name;
        nameRow.insertAdjacentElement('beforeend', groupNameSpan);

        // Vehicle Name
        const vehicleNameSpan = document.createElement('span');
        vehicleNameSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
        vehicleNameSpan.innerText = group.vehicleName;
        nameRow.insertAdjacentElement('beforeend', vehicleNameSpan);

        // Priority
        if (group.priority) {
          let priorityRow = document.createElement('div');
          priorityRow.classList.add("group-info-row");

          const icon = this.$priorityIcon.cloneNode(true);
          icon.classList.add("bringoz-icon-small", "gray", "group-icon");
          priorityRow.insertAdjacentElement('beforeend', icon);

          const priorityRowSpan = document.createElement('span');
          priorityRowSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
          priorityRowSpan.innerText = group.priority;
          priorityRow.insertAdjacentElement('beforeend', priorityRowSpan);

          nameRow.insertAdjacentElement('beforeend', priorityRow);
        }

        // Skills
        let skillsRow;
        if (this.groupsViewSettings.skills && group.requiredSkills?.length) {
          skillsRow = document.createElement('div');
          skillsRow.classList.add("group-info-row");

          group.requiredSkills.forEach((s) => {
            const skill = document.createElement('div');
            skill.classList.add('skill-tag');

            const skillText = document.createElement('span')
            skillText.textContent = s;
            skill.appendChild(skillText);
            skillsRow.insertAdjacentElement('beforeend', skill);
          })
        }

        // Branches Row
        let branchesRow;
        if (this.groupsViewSettings.branches) {

          branchesRow = document.createElement('div');
          branchesRow.classList.add("group-info-row");

          const icon = this.$branchIcon.cloneNode(true);
          icon.classList.add("bringoz-icon-small", "gray", "group-icon");
          branchesRow.insertAdjacentElement('beforeend', icon);

          if (group.branchReferences?.length) {
            const branchesSpan = document.createElement('span');
            branchesSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            branchesSpan.innerText = group.branchReferences[0].name;

            branchesRow.insertAdjacentElement('beforeend', branchesSpan);

            if (group.branchReferences.length > 1) {
              const extraBranchesButton: any = document.createElement('div');
              extraBranchesButton.classList.add("extra-branches-count");
              extraBranchesButton.innerHTML = `+${group.branchReferences.length - 1}`;
              if (group.id) {
                extraBranchesButton.dataset.bzAction = 'show-branches';
                extraBranchesButton.dataset.bzId = String(group.id);
              }
              branchesRow.insertAdjacentElement('beforeend', extraBranchesButton);
            }
          } else {
            const allSpan = document.createElement('span');
            allSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            allSpan.textContent = this.$filter('translate')('All');
            branchesRow.insertAdjacentElement('beforeend', allSpan);
          }
        }

        // Service Areas Row
        let serviceAreasRow;
        if (this.groupsViewSettings.serviceAreas) {

          serviceAreasRow = document.createElement('div');
          serviceAreasRow.classList.add("group-info-row");

          const icon = this.$serviceAreaIcon.cloneNode(true);
          icon.classList.add("bringoz-icon-small", "gray", "group-icon");
          serviceAreasRow.insertAdjacentElement('beforeend', icon);

          if (group.ref.serviceAreaIds?.length) {
            const serviceAreasSpan = document.createElement('span');
            serviceAreasSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            const serviceAreas = this._getServiceAreasByMap(group.ref.serviceAreaIds)
            serviceAreasSpan.textContent = _.get(serviceAreas, '[0].areaName');


            serviceAreasRow.insertAdjacentElement('beforeend', serviceAreasSpan);

            if (group.ref.serviceAreaIds.length > 1) {
              const extraServiceAreasButton: any = document.createElement('div');
              extraServiceAreasButton.classList.add("extra-serviceAreas-count");
              extraServiceAreasButton.innerHTML = `+${group.ref.serviceAreaIds.length - 1}`;
              if (group.id) {
                extraServiceAreasButton.dataset.bzAction = 'show-service-areas';
                extraServiceAreasButton.dataset.bzId = String(group.id);
              }
              serviceAreasRow.insertAdjacentElement('beforeend', extraServiceAreasButton);
            }
          } else {
            const allSpan = document.createElement('span');
            allSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            allSpan.textContent = this.$filter('translate')('All');
            serviceAreasRow.insertAdjacentElement('beforeend', allSpan);
          }
        }

        // Resource Tags Row
        let resourceTagsRow;
        if (this.groupsViewSettings.resourceTags) {

          resourceTagsRow = document.createElement('div');
          resourceTagsRow.classList.add("group-info-row");

          if (group.ref.tags?.length) {

            const icon = this.$resourceTagsIcon.cloneNode(true);
            icon.classList.add("bringoz-icon-small", "gray", "group-icon");
            resourceTagsRow.insertAdjacentElement('beforeend', icon);
            const resourceTagsSpan = document.createElement('span');
            resourceTagsSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            resourceTagsSpan.textContent = group.ref.tags[0];

            resourceTagsRow.insertAdjacentElement('beforeend', resourceTagsSpan);

            if (group.ref.tags.length > 1) {
              const extraResourceTagsButton: any = document.createElement('div');
              extraResourceTagsButton.classList.add("extra-resourceTags-count");
              extraResourceTagsButton.innerHTML = `+${group.ref.tags.length - 1}`;
              if (group.id) {
                extraResourceTagsButton.dataset.bzAction = 'show-resource-tags';
                extraResourceTagsButton.dataset.bzId = String(group.id);
              }
              resourceTagsRow.insertAdjacentElement('beforeend', extraResourceTagsButton);
            }
          }
        }

        // Default Agent Row
        let defaultAgentRow;
        if (this.groupsViewSettings.defaultAgent) {

          defaultAgentRow = document.createElement('div');
          defaultAgentRow.classList.add("group-info-row");

          const icon = this.$defaultAgentIcon.cloneNode(true);
          icon.classList.add("bringoz-icon-small", "gray", "group-icon");
          defaultAgentRow.insertAdjacentElement('beforeend', icon);

          const defaultAgentRowSpan = document.createElement('span');
          defaultAgentRowSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
          defaultAgentRowSpan.innerText = group.agentName;
          defaultAgentRow.insertAdjacentElement('beforeend', defaultAgentRowSpan);
        }

        // Vehicle Row
        let vehicleRow;
        if (this.groupsViewSettings.vehicle) {

          vehicleRow = document.createElement('div');
          vehicleRow.classList.add("group-info-row");

          const icon = this._getVehicleIcon(group.vehicleType);
          vehicleRow.insertAdjacentElement('beforeend', icon);

          const attachedVehicles = _.reduce(_.get(group, 'ref.attachedLogisticsVehicleReferences'), (namesString, vehicle) => {
            return namesString += `${namesString.length ? ' ' : ''}${vehicle.name}`;
          }, '');
          const vehicleRowSpan = document.createElement('span');
          vehicleRowSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
          vehicleRowSpan.textContent = `${(_.get(group, 'mainLogisticsVehicleReference.name') ? ` (${group.mainLogisticsVehicleReference.name})` : '')}${attachedVehicles ? ' ' + attachedVehicles : ''}`;
          vehicleRow.insertAdjacentElement('beforeend', vehicleRowSpan);
        }

        let blockedResourcesRow;
        if (this.groupsViewSettings.blockedResources && (group.ref.blockManualRoute || group.ref.blockPlanningRoute || group.ref.blockQuoteRoute)) {

          blockedResourcesRow = document.createElement('div');
          blockedResourcesRow.classList.add("group-info-row");

          const icon = this.$blockedResourcesIcon.cloneNode(true);
          icon.classList.add("bringoz-icon-small", "gray", "group-icon");
          blockedResourcesRow.insertAdjacentElement('beforeend', icon);

          const blockedResourcesSpan = document.createElement('span');
          blockedResourcesSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");

          let blockedResources = []
          if (group.ref.blockManualRoute) {
            blockedResources.push('Manual Routes');
          }

          if (group.ref.blockPlanningRoute) {
            blockedResources.push('Planning Routes');
          }

          if (group.ref.blockQuoteRoute) {
            blockedResources.push('Quote Routes');
          }

          blockedResourcesSpan.textContent = 'Blocked resources: ';

          blockedResourcesSpan.textContent += blockedResources[0];

          if (blockedResources.length > 1) {
            blockedResourcesSpan.textContent += '+' + (blockedResources.length - 1).toString();
          }

          blockedResourcesRow.insertAdjacentElement('beforeend', blockedResourcesSpan);
        }

        // // Tags
        // if (this.groupsViewSettings.tags && group.tags?.length) {
        //   group.tags.forEach((t) => {
        //     const tag = document.createElement('div');
        //     tag.classList.add('skill-tag');
        //
        //     const skillText = document.createElement('span')
        //     skillText.innerHTML = t;
        //     tag.appendChild(skillText);
        //     nameRow.insertAdjacentElement('beforeend', tag);
        //   })
        // }

        infoContainer.insertAdjacentElement('beforeend', nameRow);

        if (skillsRow) {
          infoContainer.insertAdjacentElement('beforeend', skillsRow.cloneNode(true));
        }

        if (branchesRow) {
          infoContainer.insertAdjacentElement('beforeend', branchesRow);
        }

        if (serviceAreasRow) {
          infoContainer.insertAdjacentElement('beforeend', serviceAreasRow);
        }

        if (resourceTagsRow) {
          infoContainer.insertAdjacentElement('beforeend', resourceTagsRow);
        }

        if (defaultAgentRow) {
          infoContainer.insertAdjacentElement('beforeend', defaultAgentRow.cloneNode(true));
        }

        if (vehicleRow) {
          infoContainer.insertAdjacentElement('beforeend', vehicleRow.cloneNode(true));
        }

        if (blockedResourcesRow) {
          infoContainer.insertAdjacentElement('beforeend', blockedResourcesRow.cloneNode(true));
        }

        mainContainer.insertAdjacentElement('beforeend', colorContainer);
        mainContainer.insertAdjacentElement('beforeend', actionsContainer);
        // mainContainer.insertAdjacentElement('beforeend', favouriteContainer);
        mainContainer.insertAdjacentElement('beforeend', infoContainer);

        if (!group.isActive) {
          const inactiveTagDiv = document.createElement('div');
          const inactiveTagSpan = document.createElement('span');
          inactiveTagSpan.textContent = this.$filter('translate')('Blocked');
          inactiveTagDiv.classList.add("inactive-tag");
          inactiveTagDiv.appendChild(inactiveTagSpan);
          // actionsContainer.appendChild(inactiveTagDiv);
          nameRow.insertAdjacentElement('beforeend', inactiveTagDiv);

          mainContainer.classList.add("inactive");
        }

        return mainContainer;
      },
      // groupTemplate: (group) => {
      //
      //   const groupColor = this.commonsService.getColorById(group.id);
      //
      //   const container = document.createElement('div');
      //   container.classList.add("group-info-container");
      //
      //   const mainContainer = document.createElement('div');
      //   mainContainer.classList.add("group-info-main-container");
      //
      //   const actionsContainer: any = document.createElement('div');
      //   actionsContainer.classList.add("group-info-actions-container");
      //   actionsContainer.style = 'background-color: ' + groupColor;
      //
      //   const routeNameSpan = document.createElement('span');
      //   routeNameSpan.classList.add("route-name");
      //   routeNameSpan.innerText = group.name;
      //
      //   const resourceCheckbox: any = document.createElement("INPUT");
      //   resourceCheckbox.setAttribute("type", "checkbox");
      //   if (this.selectedResourceIds.includes(group.id)) {
      //     resourceCheckbox.setAttribute("checked", true);
      //   }
      //   actionsContainer.appendChild(resourceCheckbox);
      //
      //   const actionButton = this.$menuIcon.cloneNode(true);
      //   actionButton.classList.add("md-icon-button", "group-action-button", "bringoz-icon");
      //
      //   actionsContainer.appendChild(angular.copy(this.$groupIcon));
      //   actionsContainer.appendChild(routeNameSpan);
      //   // actionsContainer.appendChild(growSpan);
      //   actionsContainer.appendChild(actionButton);
      //
      //   if (!group.isActive) {
      //     const inactiveTagDiv = document.createElement('div');
      //     const inactiveTagSpan = document.createElement('span');
      //     inactiveTagSpan.innerHTML = this.$filter('translate')('Blocked');
      //     inactiveTagDiv.classList.add("inactive-tag");
      //     inactiveTagDiv.appendChild(inactiveTagSpan);
      //     actionsContainer.appendChild(inactiveTagDiv);
      //
      //     container.classList.add("inactive");
      //   }
      //
      //   const attachedVehicles = _.reduce(_.get(group, 'ref.attachedLogisticsVehicleReferences'), (namesString, vehicle) => {
      //     return namesString += `${namesString.length ? ' ' : ''}${vehicle.name}`;
      //   }, '');
      //
      //   const values = [
      //     {icon: this.$agentTypeIcon, key: 'Agent Type', values: [group.agentType, group.requiredSkills]},
      //     {icon: this.$defaultAgentIcon, key: 'Default Agent', value: group.agentName},
      //     {
      //       icon: this._getVehicleIcon(group.vehicleType), key: 'Vehicle', value:
      //         `${group.vehicleName} ${(_.get(group, 'mainLogisticsVehicleReference.name') ? ` (${group.mainLogisticsVehicleReference.name})` : '')}${attachedVehicles ? ' ' + attachedVehicles : ''}`
      //     },
      //     {icon: this.$serviceAreaIcon, key: 'Service Areas', value: _.get(group, 'ref.serviceAreaIds', [])},
      //     {icon: this.$branchIcon, key: 'Branch', value: group.branchIds}
      //   ];
      //
      //   if (this.splitService.getSupportResourcePriority()) {
      //     values.push({icon: this.$priorityIcon, key: 'Priority', value: group.priority || '--'})
      //   }
      //
      //   _.forEach(values, (v, index) => {
      //
      //     const element = document.createElement('div');
      //     element.classList.add("table-item");
      //
      //     const iconContainer = document.createElement('div');
      //     iconContainer.classList.add("icon-container");
      //
      //     const icon = angular.copy(v.icon);
      //
      //     if (v.key === 'Agent Type') {
      //
      //       element.insertAdjacentElement('beforeend', iconContainer);
      //
      //       _.forEach(v.values, (value, index) => {
      //         if (index === 0) {
      //           const span = document.createElement('span');
      //           span.innerHTML = value;
      //           element.insertAdjacentElement('beforeend', span);
      //         }
      //         if (index === 1) {
      //           _.forEach(value, (s, i) => {
      //             const skill = document.createElement('div');
      //             skill.classList.add('skill-tag');
      //
      //             const skillText = document.createElement('span')
      //             skillText.innerHTML = s;
      //             skill.appendChild(skillText);
      //             // element.appendChild(skill);
      //             element.insertAdjacentElement('beforeend', skill);
      //           })
      //         }
      //       });
      //
      //       container.insertAdjacentElement('beforeend', element);
      //
      //     } else {
      //       const tooltip = document.createElement('div');
      //       tooltip.classList.add("timeline-tooltip");
      //
      //       const tooltipContainer = document.createElement('div');
      //       tooltipContainer.classList.add('tooltip-container');
      //
      //       let serviceAreas;
      //       if (v.key === 'Service Areas') {
      //         serviceAreas = this._getServiceAreasByMap(group.ref.serviceAreaIds);
      //         const serviceAreasSpan = document.createElement('span');
      //         serviceAreasSpan.innerHTML = _.join(_.map(serviceAreas, 'areaName'), ', ');
      //         if (!!serviceAreas.length) {
      //           tooltipContainer.appendChild(serviceAreasSpan);
      //         } else {
      //           tooltipContainer.innerHTML = '';
      //         }
      //         // tooltipContainer.innerHTML = _.join(_.map(serviceAreas, 'areaName'), ', ');
      //       } else if (v.key === 'Branch' && !!group.branchReferences.length) {
      //         const branchesSpan = document.createElement('span');
      //         branchesSpan.innerHTML = _.join(_.map(group.branchReferences, 'name'), ', ');
      //         tooltipContainer.appendChild(branchesSpan);
      //         // tooltipContainer.innerHTML = _.join(_.map(serviceAreas, 'areaName'), ', ');
      //       } else {
      //         tooltipContainer.innerHTML = '';
      //       }
      //
      //       tooltip.insertAdjacentElement('beforeend', tooltipContainer);
      //       iconContainer.insertAdjacentElement('beforeend', icon);
      //       iconContainer.insertAdjacentElement('beforeend', tooltip);
      //
      //       const span = document.createElement('span');
      //
      //       if (v.key === 'Service Areas') {
      //         span.innerHTML = (!v.value.length ? this.$filter('translate')('All') : (v.value.length === 1 ? ('1 - ' + _.get(serviceAreas, '[0].areaName', '---')) : this.$filter('translate')('X_SERVICE_AREAS', v.value)));
      //       } else if (v.key === 'Branch') {
      //         span.innerHTML = v.value.length === 1 ? ('1 - ' + _.get(group, 'branchReferences[0].name')) : this.$filter('translate')('X_BRANCHES', v.value);
      //       } else {
      //         span.innerHTML = _.isArray(v.value) ? v.value.length : v.value;
      //       }
      //
      //       element.insertAdjacentElement('beforeend', iconContainer);
      //       element.insertAdjacentElement('beforeend', span);
      //       container.insertAdjacentElement('beforeend', element);
      //     }
      //   });
      //
      //   mainContainer.insertAdjacentElement('beforeend', actionsContainer);
      //   mainContainer.insertAdjacentElement('beforeend', container);
      //
      //   actionButton.addEventListener("click", (event) => {
      //     this._onClicked().then(() => {
      //       if (group.id) {
      //         this.onResourceAction({resource: group.ref, event: event});
      //       }
      //     });
      //   }, {passive: true});
      //
      //   resourceCheckbox.addEventListener("click", event => {
      //     this._onClicked().then(() => {
      //       if (group.id) {
      //         this.onResourceSelect({resourceId: group.id, event: event});
      //       }
      //     });
      //   }, {passive: true})
      //
      //   return mainContainer;
      // },
      onMoving: (item, callback) => {
        // if (item.stopId) {
        //     callback(item); // updating the item
        // }
        // else {
        //     callback(null); // cancel updating the item
        // }
        callback(item); // updating the item
      },
      onMove: (item, callback) => {
        this.onMoveAllocation({allocation: item});
      },
      snap: (date, scale, step) => {
        const fifteenMinutes = 60 * 1000 * 15; // ticks of 15 minutes
        return Math.round(date / fifteenMinutes) * fifteenMinutes;
      },
      orientation: 'top',
      // editable: true,
      selectable: true,
      multiselect: true,
      // multiselectPerGroup: true,
      editable: {
        add: false,                          // add new items by double tapping
        updateTime: false,                // drag items horizontally
        updateGroup: false,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: false          // allow these options to override item.editable
      },
      verticalScroll: true,
      groupHeightMode: 'auto',
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      margin: {
        item: {horizontal: 0, vertical: 10},
        axis: 5
      },
      stack: true,
      tooltip: {
        followMouse: true
      },
      format: {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          millisecond: this.timeFormat,
          second: this.timeFormat,
          weekday: 'ddd ' + this.longDateFormat,
          day: 'ddd ' + this.longDateFormat,
          week: 'ddd ' + this.longDateFormat,
          month: 'ddd ' + this.longDateFormat,
          year: 'ddd ' + this.longDateFormat
        },
        majorLabels: {
          minute: 'ddd ' + this.longDateFormat,
          hour: 'ddd ' + this.longDateFormat,
          millisecond: 'ddd ' + this.longDateFormat,
          second: 'ddd ' + this.longDateFormat,
          weekday: '',
          day: 'ddd ' + this.longDateFormat,
          week: '',
          month: '',
          year: ''
        }
      },
      // maxMinorChars: 5,
      start: this.range.from ? this.moment(this.range.from).subtract(1, 'hour') : this.moment().startOf('day'),
      end: this.range.to ? this.moment(this.range.to).add(1, 'hour') : this.moment().endOf('day'),
      min: this.range.from ? this.moment(this.range.from) : this.moment().startOf('day'),
      max: this.range.to ? this.moment(this.range.to) : this.moment().endOf('day'),
      zoomMin: 1080000 // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,


    }

    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    // Set Table Actions
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("resources-list-header-container");

    // var addResourceButton = document.createElement('md-button');
    // addResourceButton.classList.add("md-raised", "md-accent");
    // addResourceButton.innerHTML = '+ ' +  $filter('translate')('Add Resource');
    // tableHeaderDivRef.appendChild(addResourceButton);

    topElementRef.before(this.tableHeaderDivRef);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Init Groups/Items Data
    this._initTimelineData(this.resources, this.allocations);
    this._scheduleTimelineRedraw();

    // Timeline Events
    // this.timeline.on('select', (properties) => {
    //   properties.event.preventDefault();
    //   this._onClicked().then(() => {
    //     const selectedAllocationIds = this.timeline.getSelection();
    //     this.onHighlightAllocations({allocationIds: selectedAllocationIds});
    //     properties.event.preventDefault();
    //   });
    // });

    // DoubleClick Event
    this.timeline.on('doubleClick', (properties) => {
      if (properties.group && !_.get(properties, 'item')) {
        this._onClicked().then(() => {
          const resource = _.find(this.resources, (r) => {
            return r.id === properties.group
          });
          if (resource) {
            let selectedDate = undefined;
            let itemData = undefined;
            if (_.isEqual(_.get(properties, 'what'), 'background') && _.get(properties, 'time')) {
              selectedDate = (properties.time).getTime();
              itemData = {
                startDate: this.moment(selectedDate).startOf('day').valueOf(),
                endDate: this.moment(selectedDate).endOf('day').minute(45).seconds(0).millisecond(0).valueOf()
              }
            }
            this.onCreateAllocation({resource: resource, itemData: itemData});
          }
        });
      }
    });

    // Click Event
    this.timeline.on('click', (properties) => {
      if (properties.item && (properties.event.ctrlKey || properties.event.metaKey)) {
        this._onClicked().then(() => {


          if (this.highlightedAllocations?.length) {
            const clickedAllocationItem = this._getTimelineAllocationById(properties.item);
            const highlightedAllocationsResourceId = this._getTimelineAllocationById(this.highlightedAllocations[0].id).ref.resourceAllocationId;

            //Check if highlighted allocation's resource matches the previous highlight allocation resource

            if (clickedAllocationItem.ref.resourceAllocationId !== highlightedAllocationsResourceId) {
              this.onHighlightAllocations({allocations: [clickedAllocationItem.ref]});
            } else {
              const selectedAllocationIds = this.timeline.getSelection();
              const allocations = [];

              selectedAllocationIds.forEach((id) => {
                const allocationItem = this._getTimelineAllocationById(id);
                allocations.push(allocationItem.ref);
              })

              this.onHighlightAllocations({allocations: allocations});
            }
          } else {
            const selectedAllocationIds = this.timeline.getSelection();
            const allocations = [];

            selectedAllocationIds.forEach((id) => {
              const allocationItem = this._getTimelineAllocationById(id);
              allocations.push(allocationItem.ref);
            })

            this.onHighlightAllocations({allocations: allocations});
          }
          // properties.event.preventDefault();
        });
        // props.event.preventDefault(); // Prevent the browser context menu
        // highlightItem(props.item);
      } else if (properties.item && !properties.event.ctrlKey && !properties.event.metaKey) {
        this._onClicked().then(() => {
          const selectedAllocation = this._getTimelineAllocationById(properties.item);
          const resource = _.find(this.resources, (r) => {
            return properties.group === r.id;
          })

          if (selectedAllocation && selectedAllocation.itemType === 'ResourceAllocation') {
            // open allocation panel
            const itemData = {
              id: properties.item,
              startDate: selectedAllocation.startTime,
              endDate: selectedAllocation.endTime
            }
            this.onAllocationSelection({allocation: selectedAllocation.ref, resource: resource, itemData: itemData});
          }

        });
      }
    });

    // Right Click Event
    this.timeline.on('contextmenu', (props) => {
      if (props.item) {
        const allocation = this._getTimelineAllocationById(props.item);
        const itemData = {
          id: props.item,
          startDate: allocation.startTime,
          endDate: allocation.endTime
        }
        if (allocation) {
          this._onClicked().then(() => {
            this.onAllocationRightClick({
              allocation: allocation.ref,
              range: {from: this.moment(allocation.startTime).valueOf(), to: this.moment(allocation.endTime).valueOf()},
              itemData: itemData,
              hasRelatedRoutes: false,
              event: props.event
            })
          });
        }
      }
      props.event.preventDefault();
    });

  }

  $onDestroy() {
    if (this._redrawTimeoutHandle) {
      this.$timeout.cancel(this._redrawTimeoutHandle);
    }
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    let shouldRedrawTimeline = false;

    if (changes.resources && !changes.resources.isFirstChange()) {
      this.groupsDataSet.clear();
      this.groupsDataSet.add(this._getGroupsData(this.resources));
      this.itemsDataSet.clear();
      this.itemsDataSet.add(this._getItemsData(this.allocations));
      shouldRedrawTimeline = true;
    }

    if (changes.allocations && !changes.allocations.isFirstChange()) {
      this.itemsDataSet.clear();
      this.itemsDataSet.add(this._getItemsData(this.allocations));
      shouldRedrawTimeline = true;
    }

    if (changes.selectedResourceIds && !changes.selectedResourceIds.isFirstChange()) {
      const groupsToUpdate = [];
      this.groupsDataSet.forEach((group) => {
        groupsToUpdate.push(group);
      });
      this.groupsDataSet.update(groupsToUpdate);
      shouldRedrawTimeline = true;
    }

    if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
      const selectedTask = this._getTimelineAllocationById(this.selectedItemId);
      if (selectedTask) {
        this.timeline.setSelection(selectedTask.id);
      }
    }

    if (changes.highlightedAllocations && !changes.highlightedAllocations.isFirstChange()) {
      const allocationIds = this.highlightedAllocations.map(a => a.id);
      this.timeline.setSelection(allocationIds);
      this._updateTimelineSelectedTassStyle();
    }

    if (changes.range && !changes.range.isFirstChange()) {
      this.options.min = this.moment(this.range.from);
      this.options.max = this.moment(this.range.to);
      this.timeline.setOptions(this.options);
      this.timeline.setWindow(new Date(this.range.from), new Date(this.range.to));
      shouldRedrawTimeline = true;
    }

    if (shouldRedrawTimeline) {
      this._scheduleTimelineRedraw();
    }

  };

  // ******************************
  //        Public methods
  // ******************************

  // function onFit() {
  //     timeline.fit();
  // }

  onGroupsViewSettingsChange(updatedGroupsViewSettings) {
    this.groupsViewSettings = updatedGroupsViewSettings;
    this._redrawGroupTemplate();
  }

  public onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _redrawGroupTemplate() {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
    this._scheduleTimelineRedraw();
  }

  private _scheduleTimelineRedraw() {
    if (this._redrawTimeoutHandle) {
      this.$timeout.cancel(this._redrawTimeoutHandle);
    }
    this._redrawTimeoutHandle = this.$timeout(() => {
      if (this.timeline) {
        this.timeline.redraw();
      }
      this._redrawTimeoutHandle = undefined;
    }, 0);
  }

  private _getGroupsData(resources) {
    return _.map(resources, (r) => {

      return {
        id: r.id,
        name: r.name,
        vehicleName: _.get(r, 'vehicle.name', '---'),
        vehicleType: _.get(r, 'vehicle.type'),
        agentType: this.$filter('translate')(_.get(r, 'agentType', '')),
        requiredSkills: this._getTranslatedResourceSkills(r),
        mainLogisticsVehicleReference: _.get(r, 'mainLogisticsVehicleReference'),
        agentName: r.agentName || '---',
        branchIds: _.get(r, 'branchIds', []),
        branchReferences: _.get(r, 'branchReferences', []),
        maxDeliveries: _.get(r, 'capacity.numberOfDeliveries', '---'),
        className: 'group-row br-caption-2',
        isActive: r.isActive,
        priority: r.priority,
        ref: r
      }
    });
  }

  private _getTranslatedResourceSkills(resource, isFirstLetterOnly?) {
    return _.map(resource.requiredSkills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }

  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }

  private _getItemsData(allocations) {
    let allAllocationItems = [];
    const monthInMili = 2592000000;

    const resourceAllocations = _.filter(allocations, (a) => {
      return a.type === 'ResourceAllocation';
    })

    _.forEach(resourceAllocations, (a) => {

      const allocationRecurringString = _.get(a, 'schedule.rrule', '');

      // OLD IMPLEMENTATION
      if (allocationRecurringString && false) {
        const ruleOptions = this.rrule.RRule.parseString(allocationRecurringString);

        ruleOptions.dtstart = this.moment(a.schedule.startRecurring).utc(true).toDate()
        if (a.schedule.endRecurring) {
          ruleOptions.until = this.moment(a.schedule.endRecurring).utc(true).toDate();
        }

        const rule = new this.rrule.RRule(ruleOptions);
        let dates = rule.between(new Date(this.range.from), new Date(this.range.to));

        // convert to local
        dates = _.map(dates, (d) => {
          return this.moment(d).set({
            year: this.moment.utc(d).year(),
            month: this.moment.utc(d).month(),
            date: this.moment.utc(d).date()
          }).startOf('day').toDate();
        })

        const exceptions = _.get(a, 'schedule.exceptions', []);


        allAllocationItems = allAllocationItems.concat(
          this._parseReacquiringAllocationByTypeToItems(a, dates, exceptions, a.type) //ResourceAllocation | AgentSchedule
        );
      } else {
        allAllocationItems.push(this._parseTimeWindowAllocationToItem(a));
        // allAllocationItems.push(
        //   a.type === 'ResourceAllocation' ? // AgentSchedule
        //     this._parseTimeWindowAllocationToItem(a) :
        //     this._parseAgentAllocationToItem(a)
        // );
      }
    });

    return allAllocationItems;
  }

  private _initTimelineData(resources, allocations) {
    const groups = this._getGroupsData(resources);
    const items = this._getItemsData(allocations);

    this.groupsDataSet.add(groups);
    this.itemsDataSet.add(items);
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineAllocationById(id) {
    if (!id) {
      return undefined;
    }
    return this.itemsDataSet.get(id);
  }

  // private _getItemServiceAreaText(serviceAreas) {
  //   return serviceAreas.length > 1 ?
  //     _.toString(serviceAreas.length) + ' Service Areas' :
  //     _.get(serviceAreas, '[0].areaName', '');
  // }
  //
  // private _setGroupVisibilityByQueryString(queryString) {
  //   const updatedGroups = [];
  //
  //   this.groupsDataSet.forEach((group) => {
  //     group.visible = !queryString ||
  //       _.includes(_.toLower(group.name), _.toLower(queryString)) ||
  //       _.includes(_.toLower(group.agentName), _.toLower(queryString));
  //     updatedGroups.push(group);
  //   });
  //
  //   this.timeline.setGroups(updatedGroups);
  // }

  private _getServiceAreasByMap(areaIds) {
    return _.chain(areaIds).map((areaId) => {
      return this.serviceAreasMap[areaId];
    }).filter((value) => {
      return !!value;
    })
      .value();
  }

  private _getBranchesReferencesFromResource(resourceId, branchIds) {
    const resource = this.resources.find(r => r.id === resourceId);

    if (!branchIds?.length) {
      return resource.branchReferences || [];
    } else {
      return resource?.branchReferences?.filter((br) => branchIds.includes(br.id));
    }
  }

  private _getVehicleIcon(vehicleClass) {

    if (!vehicleClass) {
      vehicleClass = 'truck';
    }

    const $vehicleIcon = document.createElement('IMG');
    $vehicleIcon.setAttribute("src", `assets/images/icons/v2/${vehicleClass.toLowerCase()}.svg`);
    $vehicleIcon.classList.add("bringoz-icon-small", "gray", "group-icon");
    return $vehicleIcon;
  }

  private _getTimeWindowAllocationContent(allocation, agentReference, notBefore, notAfter, warnings?) {
    const isRecurring = !!allocation.templateId && !allocation.template && !allocation.overridden;
    const routeIds = allocation.scheduleExtraData?.routeIds || [];

    const timeWindowTextRef = this.$filter('timeWindow')({
      notBefore: this.moment(notBefore).valueOf(),
      notAfter: this.moment(notAfter).valueOf()
    });

    let routeButton;
    if (routeIds.length) {
      routeButton = document.createElement('md-button');
      routeButton.classList.add('md-icon-button', 'route-button', 'item-row');
      const routeIconElement = document.createElement('IMG');
      routeIconElement.setAttribute("src", this.iconsUrl.routed);
      routeIconElement.classList.add('bringoz-icon-small', 'white', 'margin-right-0');
      routeButton.appendChild(routeIconElement);
    }

    const timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(allocation.schedule.zoneIdName ? allocation.schedule.zoneIdName : allocation.resourceZoneId, allocation.schedule.startTime);
    let timeWindowZoneRow = '';
    let agentRow = '';

    if (!_.isUndefined(timeZoneOffsetDiff) && timeZoneOffsetDiff !== 0) {
      timeWindowZoneRow = '<div class="info-row">'
        + this.$timeZoneIcon.outerHTML
        + '</div>'
    }

    if (!!agentReference) {
      const agentIcon = this.$defaultAgentIcon.cloneNode(true);
      agentIcon.classList.add("margin-0", "white", "bringoz-icon", "margin-right-5");

      agentRow = '<div class="item-row text-ellipsis">'
        + agentIcon.outerHTML
        + '<span class="br-body-2">' + this.$filter('userName')(agentReference) + '</span>'
        + '</div>'
    }

    return '<div class="item-container">'
      + '<div class="item-row">'
      + '<span class="br-body-2">' + timeWindowTextRef + '</span>'
      + (routeIds.length ? routeButton.outerHTML : '')
      + (isRecurring ? '<span class="margin-left-5"></span>' + `${this.$recurringIcon.outerHTML}` : '')
      + timeWindowZoneRow
      // + warningIconRef
      // + '<span>' + timeWindowTextRef + ' | ' + hours + (minutesDisplay ? ':' : '') + minutesDisplay + ' ' + hoursText + '</span>'
      + '</div>'
      + agentRow
      + '</div>'

  }

  private _updateTimelineSelectedTassStyle() {
    const itemsToUpdate = [];

    this.itemsDataSet.forEach((item) => {
      const isHighlightedItem = this.highlightedAllocations.find(a => a.id === item.id);
      const color = this.commonsService.getColorById(item.ref.resourceAllocationId);

      if (isHighlightedItem) {
        let highlightedColor = this.commonsService.hexToRGBColor(color, 0.78);
        item.style = `background-color: ${highlightedColor};`;
        itemsToUpdate.push(item);
      } else {
        item.style = 'background: ' + color;
        itemsToUpdate.push(item);
      }
    });

    this.itemsDataSet.update(itemsToUpdate);
  }


  private _parseTimeWindowAllocationToItem(allocation) {
    const serviceAreas = this._getServiceAreasByMap(allocation.serviceAreaIds);
    const branchRefences = this._getBranchesReferencesFromResource(allocation.resourceAllocationId, allocation.branchIds);
    const color = this.commonsService.getColorById(allocation.resourceAllocationId);
    // const agent = _.find(this.allocations, (a) => {
    //   return a.type === 'AgentSchedule' && a.timeWindowId === allocation.id;
    // });
    return {
      start: this.isDayView ? this.moment(allocation.schedule.startTime) : this.moment(allocation.schedule.startTime).startOf('day').add(30, 'minute'),
      end: this.isDayView ? this.moment(allocation.schedule.endTime) : this.moment(allocation.schedule.endTime).endOf('day').subtract(30, 'minute'),
      startTime: allocation.schedule.startTime,
      endTime: allocation.schedule.endTime,
      id: allocation.id,
      group: allocation.resourceAllocationId,
      ref: allocation,
      title: this.bringozTimelineService.getResourceAllocationTimeWindowTooltip(allocation, serviceAreas, branchRefences),
      content: this._getTimeWindowAllocationContent(
        allocation,
        allocation.agentReference,
        allocation.schedule.startTime,
        allocation.schedule.endTime,
        allocation.warnings
      ),
      className: 'time-window',
      itemType: 'ResourceAllocation',
      style: 'background: ' + color,
    }
  }

  private _parseAgentAllocationToItem(allocation) {
    // var serviceAreas = _.map(allocation.serviceAreaIds, function (areaId) {
    //     return ctrl.serviceAreasMap[areaId];
    // });

    return {
      start: this.isDayView ? this.moment(allocation.schedule.startTime) : this.moment(allocation.schedule.startTime).startOf('day').add(30, 'minute'),
      end: this.isDayView ? this.moment(allocation.schedule.endTime) : this.moment(allocation.schedule.endTime).endOf('day').subtract(30, 'minute'),
      id: allocation.id,
      group: allocation.resourceAllocationId,
      ref: allocation,
      editable: false,
      selectable: false,
      content: this._getAgentAllocationContent(allocation),
      itemType: 'AgentSchedule',
      className: 'agent'
    }
  }

  private _parseReacquiringAllocationByTypeToItems(allocation, dates, exceptions, type) {
    const serviceAreas = this._getServiceAreasByMap(allocation.serviceAreaIds);
    const color = this.commonsService.getColorById(allocation.resourceAllocationId);

    if (exceptions.length) {
      dates = _.filter(dates, (d) => {
        const exception = _.find(exceptions, (e) => {
          return this.moment(d).isSame(this.moment(e), 'date');
        });
        return _.isUndefined(exception);
      });
    }
    return _.map(dates, (date) => {
      const dateToDifferenceInMili = this.moment(allocation.schedule.endTime).diff(this.moment(allocation.schedule.startTime));
      const dateFrom = this.moment(date).set({
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date(),
        hour: this.moment(allocation.schedule.startTime).hours(),
        minute: this.moment(allocation.schedule.startTime).minutes(),
        second: this.moment(allocation.schedule.startTime).seconds()
      });
      const dateTo = this.moment(dateFrom.valueOf() + dateToDifferenceInMili);
      // var dateTo = moment(moment(dateFrom).valueOf() + dateToDifferenceInMili).set({
      //     hour:   moment(allocation.schedule.endTime).hours(),
      //     minute: moment(allocation.schedule.endTime).minutes(),
      //     second: moment(allocation.schedule.endTime).seconds()
      // });
      return {
        id: this.moment(date).valueOf() + '-' + allocation.id, //ResourceAllocation | AgentSchedule
        start: this.isDayView ? this.moment(dateFrom) : this.moment(dateFrom).startOf('day').add(30, 'minute'),
        end: this.isDayView ? this.moment(dateTo) : this.moment(dateTo).endOf('day').subtract(30, 'minute'),
        startTime: dateFrom,
        endTime: dateTo,
        allocationId: allocation.id,
        group: allocation.resourceAllocationId,
        ref: allocation,
        editable: type === 'AgentSchedule' ? false : undefined,
        title: type === 'ResourceAllocation' ? this.bringozTimelineService.getServiceAreasTooltip(serviceAreas) : undefined,
        content: type === 'ResourceAllocation' ?
          this._getTimeWindowAllocationContent(allocation, undefined, dateFrom, dateTo, allocation.warnings) :
          this._getAgentAllocationContent(allocation),
        className: type === 'ResourceAllocation' ? 'time-window' : 'agent',
        style: 'background: ' + (type === 'ResourceAllocation' ? color : ''),
        itemType: type,
        // style: 'background-color: ' + color + '; color: white',
      }
    })
  }

  private _getAgentAllocationContent(allocation) {
    const agentName = this.$filter('userName')(allocation.agentRef.user);
    const agentImageUrl = _.get(allocation, 'agentRef.user.avatarUrl', '/assets/images/avatars/default_user.png');
    // const timeWindowTextRef = this.$filter('timeWindow')({
    //   notBefore: this.moment(notBefore).valueOf(),
    //   notAfter: this.moment(notAfter).valueOf()
    // });
    return '<div layout="column" layout-align="center start">'
      + '<div class="agent-item-info-container">'
      + '<img src="' + agentImageUrl + '" alt="Agent image">'
      + '<div class="item-container text-ellipsis">'
      + '<span class="br-caption-2 font-weight-600">' + agentName + '</span>'
      + '<span class="br-caption-2 font-weight-400">' + this.$filter('translate')(allocation.agentRef.agentType) + '</span>'
      + '</div>'
      + '</div>'
      + '</div>'
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourcesAllocationsTimeline', {
      bindings: {
        range: '<',
        isDayView: '<',
        resources: '<',
        totalResourcesCount: '<',
        allocations: '<',
        serviceAreas: '<',
        resourceTags: '<?',
        selectedItemId: '<',
        canEdit: '<',
        queryString: '<?',
        selectedResourceIds: '<?',
        isAllResourcesSelected: '<?',
        highlightedAllocations: '<?',
        onHighlightAllocations: '&',
        onResourceSelect: '&',
        onToggleSelectAll: '&',
        onAllocationSelection: '&',
        onAllocationRightClick: '&',
        onMoveAllocation: '&',
        onCreateAllocation: '&',
        onResourceAction: '&',
        onBulkEditResourceAllocation: '&',
        onBulkEditResources: '&'
      },
      template: require('./resources-allocations-timeline.html').default,
      controller: ResourcesAllocationsTimelineCtrl
    }
  );
